import { Fragment, useState } from 'react';
import { Text } from '@ui-kitten/components';
import PropTypes from 'prop-types';

import constants from '../../Config/constants';
import ThemeStyle from '../../Theme/styles';

import Button from '../Button';
import StepSlider from '../StepSlider';

function RatingSelector({ disableReset, rating, onViewResult, onReset }) {
  const [value, setValue] = useState(rating);

  return (
    <Fragment>
      {!constants.isWeb && (
        <Text category="h6" style={ThemeStyle.spacingBottomMedium}>
          Ratings
        </Text>
      )}
      <Text appearance="hint">{value < 5 ? `Over ${value}` : value}</Text>

      <StepSlider defaultValue={value} min={3} max={5} onChange={setValue} />

      <Button
        testID="ratingViewResultButton"
        status="success"
        style={ThemeStyle.spacingBottomMedium}
        onPress={() => onViewResult(value)}
      >
        {({ style: { fontWeight, ...rest } }) => (
          <Text style={rest}>View Results</Text>
        )}
      </Button>
      <Button
        testID="ratingResetButton"
        status="control"
        onPress={onReset}
        disabled={disableReset}
      >
        {({ style: { fontWeight, ...rest } }) => (
          <Text style={rest}>Reset</Text>
        )}
      </Button>
    </Fragment>
  );
}

RatingSelector.propTypes = {
  disableReset: PropTypes.bool.isRequired,
  rating: PropTypes.number,
  onViewResult: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default RatingSelector;
